<template>
  <v-flex xs12 md6 lg4>
    <v-card>
      <v-card-title class="mt-0">
        <span class="disk-title" style="padding: 12px 0; white-space: nowrap; text-overflow: ellipsis; max-width: 50%; overflow: hidden;">{{ diskData.label }}</span>
        <v-spacer></v-spacer>
        Тип: {{ type === 'system' ? 'Системный' : 'Google Disk'}}
        <v-icon class="ml-2">{{ type === 'system' ? 'cloud_off' : 'cloud'}}</v-icon>
        <v-tooltip bottom :close-delay="authorised ? '100' : '2000'">
          <template v-slot:activator="{ on }">
            <span class="ml-3 circle" :class="authorised ? 'auth' : 'noAuth'" v-on="on"></span>
          </template>
          <span v-if="authorised">Диск авторизован</span>
          <a v-else :href="url" style="color: #ffffff;">Требуется авторизация</a>
        </v-tooltip>
        <v-menu bottom left v-if="type !== 'system'">
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon>more_vert</v-icon>
            </v-btn>
          </template>

          <v-list>
            <v-list-tile>
              <v-list-tile-content>
                <v-layout row justify-center>
                  <v-dialog v-model="deleteDialog" max-width="290">
                    <template v-slot:activator="{ on }">
                      <v-btn flat v-on="on">Удалить диск</v-btn>
                    </template>
                    <v-card>
                      <v-card-title class="headline">Вы собираетесь удалить привязанный диск.</v-card-title>
                      <v-card-text>Диск будет полностью удален, восстановление файлов не возможно.</v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="green darken-1" flat @click="deleteDialog = false">Отменить</v-btn>
                        <v-btn color="green darken-1" flat @click="deleteDisk">Удалить</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
            <v-list-tile>
              <v-list-tile-content>
                <v-layout row justify-center>
                  <v-dialog v-model="editDialog" max-width="290">
                    <template v-slot:activator="{ on }">
                      <v-btn flat v-on="on">Изменить название</v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="headline">Изменить название</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container grid-list-md>
                          <v-layout wrap>
                            <v-flex xs12>
                              <v-text-field
                                label="Название диска"
                                required
                                v-model="newLabel"
                                @keyup.enter="editLabel"
                              ></v-text-field>
                            </v-flex>
                          </v-layout>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="blue darken-1" flat @click="editDialog = false">Отмена</v-btn>
                        <v-btn color="blue darken-1" flat @click="editLabel">Изменить</v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                </v-layout>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
        </v-menu>
      </v-card-title>
      <v-divider></v-divider>
      <v-list dense v-if="!!info">
        <v-list-tile>
          <v-list-tile-content>Общее количество директорий:</v-list-tile-content>
          <v-list-tile-content class="align-end">{{ info.dir_count }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>Общее количество файлов:</v-list-tile-content>
          <v-list-tile-content class="align-end">{{ info.file_count }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>Емкость диска:</v-list-tile-content>
          <v-list-tile-content class="align-end">{{ getSize(info.total) }}</v-list-tile-content>
        </v-list-tile>
        <v-list-tile>
          <v-list-tile-content>Использовано:</v-list-tile-content>
          <v-list-tile-content class="align-end">{{ getSize(info.used) }}</v-list-tile-content>
        </v-list-tile>
      </v-list>
      <v-divider></v-divider>
      <v-card-text>
        <p class="mb-0 text-xs-center">Процент использования диска</p>
        <v-progress-linear
          active
          height="25px"
          striped
          :value="getPercentDiskUsage(info.total, info.used)"
          color="green"
          class="mt-0"
        >
          <strong class="text-xs-center d-block">{{ getPercentDiskUsage(info.total, info.used) }}%</strong>
        </v-progress-linear>
      </v-card-text>
    </v-card>
  </v-flex>
</template>

<script>
export default {
  name: "DiskItem",
  props: {
    diskData: {
      type: Object
    }
  },
  data() {
    return {
      info: [],
      url: "",
      editDialog: false,
      deleteDialog: false,
      newLabel: this.diskData.label,
      id: this.diskData.id,
      authorised: this.diskData.authorised,
      type: this.diskData.type
    };
  },
  created() {
    this.$store.dispatch("disk/getDiskInfo", this.id).then(response => {
      this.info = response;
    });
    if (!this.authorised) {
      this.$store.dispatch("disk/getAuthLink", this.id).then(response => {
        const encodeUrl = encodeURI(response.auth_url);
        this.url = decodeURI(encodeUrl);
        const regex = new RegExp("[?&]" + "state" + "(=([^&#]*)|&|#|$)");
        const results = regex.exec(this.url);
        const sessionId = JSON.stringify([this.diskData.company_id, this.id]);
        sessionStorage.setItem(
          decodeURIComponent(results[2].replace(/\+/g, " ")),
          sessionId
        );
      });
    }
  },
  methods: {
    getAuthLink() {
      this.$store
        .dispatch("disk/getAuthLink", this.id)
        .then(response => {
          this.url = response.auth_url;
        })
        .catch(error => {
          this.$dmsErrorNoty("Возникла ошибка при авторизации");
          throw error;
        });
    },
    getSize(bytes, decimals = 2) {
      if (bytes === null || bytes === 0) return "0 Байт";
      const k = 1024;
      const dm = decimals < 0 ? 0 : decimals;
      const sizes = ["Байт", "КБайт", "МБайт", "ГБайт", "ТБайт"];
      const i = Math.floor(Math.log(bytes) / Math.log(k));
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + " " + sizes[i];
    },
    getPercentDiskUsage(total, used) {
      const percent = Math.floor(total / 100);
      return Math.ceil(used / percent);
    },
    deleteDisk() {
      this.$store
        .dispatch("disk/deleteDisk", this.id)
        .then(response => {
          this.$dmsSuccessNoty("Диск успешно удален");
          this.$store.commit("disk/deleteDisk", this.id);
          this.deleteDialog = !this.deleteDialog;
        })
        .catch(error => {
          if (error.response.status == 403)
            this.$dmsErrorNoty("Для данного пользователя удаление запрещено");
        });
    },
    editLabel() {
      let oldLabel = this.newLabel;
      let data = {
        label: this.newLabel
      };
      this.$store
        .dispatch("disk/editLabel", { id: this.id, data })
        .then(response => {
          this.$dmsSuccessNoty("Диск успешно переименован");
          this.$store.commit("disk/editLabel", response);
          this.editDialog = false;
        })
        .catch(error => {
          this.diskData.label = this.oldLabel;
          if (error.response.status == 403) {
            this.$dmsErrorNoty(
              "Для данного пользователя переименование запрещено"
            );
          } else {
            this.$dmsErrorNoty("Возникла ошибка при переименовании диска");
          }
          throw error;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.circle {
  width: 13px;
  height: 13px;
  background-color: trasparent;
  border-radius: 8px;

  &.auth {
    background: #1fef1f;
  }

  &.noAuth {
    background: red;
  }
}
</style>


// WEBPACK FOOTER //
// src/apps/disk/components/Dashboard/DiskItem.vue